"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adyenCustomCss = void 0;
var adyenCustomCss = function adyenCustomCss() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#3b3b3b';
  var fontWeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  return {
    card: {
      styles: {
        placeholder: {
          color: color,
          fontWeight: fontWeight
        }
      },
      use: true
    },
    storedCard: {
      styles: {
        placeholder: {
          color: color,
          fontWeight: fontWeight
        }
      }
    }
  };
};
exports.adyenCustomCss = adyenCustomCss;